import styled from 'styled-components';

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 2px;
  border-color: gray;
  margin-left: 10px;
  overflow: hidden;
  background-color: #fff;

  thead {
    th {
      font-size: 12px;
      padding: 2px;
      border: 1px solid #ccc;
    }
  }

  tbody {
    border-color: inherit;
    text-align: center;

    td {
      font-size: 12px;
      border: 1px solid #ccc;
    }
  }
`;
